import { Component, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';

export interface YesNoModel {
  title: string;
  message: string;
  comment: string;
  confirmButtonText: string;
  cancelButtonText: string;
}

@Component({
  selector: 'yesno',
  template: `<div class="modal-dialog" style="none!important;width:380px!important;top:50px!important;">
                <div class="modal-content bgd-c" style="border:none!important;">                   
                   <div class="modal-body" style="border:none!important;">
                     <p class="h6" style="color:white!important;">{{title || 'Confirmation'}}</p>
                     <small class="extra-clr ft-c">{{message}}</small><br/>
                     <small class="text-small" style="color:white!important;font-size:10px!important">{{comment}}</small>                   
                   <div style="border:none!important;height:20px!important;margin-top:5px!important;">                     
                     <button type="button" class="btn btn-danger btn-sm pull-right" style="margin-right:4px!important;" (click)="cancel()">{{cancelButtonText || 'No'}}</button>
                     <button type="button" class="btn btn-primary btn-sm pull-right" style="margin-right:4px!important;padding-right:4px!important;" (click)="confirm()">{{confirmButtonText || 'Yes'}}</button>
                   </div>
                  </div>
                 </div>
                </div>`,
  styles: [`
   .bgd-c{background:rgb(57, 50,118 )!important;}
   .ft-c{color: rgb(253, 207,76 )!important;}   
 `]
})
export class YesNoComponent extends DialogComponent<YesNoModel, boolean> implements YesNoModel {
  title: string;
  message: string;
  comment: string;
  confirmButtonText: string;
  cancelButtonText: string;  

  constructor(dialogService: DialogService) {
    super(dialogService);
  } 

  confirm() {
    // on click on confirm button we set dialog result as true,
    // ten we can get dialog result from caller code
    this.result = true;
    this.close();
  }
  cancel() {
    this.result = false;
    this.close();
  }
}
